export const getGoogleAnalyticsClientId = (): string | null => {
  if (typeof window === 'undefined') return null;

  // Get the _ga cookie
  const cookies = document.cookie.split(';');
  const gaCookie = cookies.find((cookie) => cookie.trim().startsWith('_ga='));

  if (gaCookie) {
    // Extract the client ID from _ga cookie
    // Format: _ga=GA1.1.123456789.1234567890
    const clientId = gaCookie.split('=')[1];
    if (clientId) {
      return clientId;
    }
  }

  return null;
};
